import { memo } from 'react';
import { Refreshing } from '../../functions/useRefreshing';
import { WorkshopJob } from '../../functions/workshopJobFromItem';
import { BoardTable } from '../board-table';
import { JobRow } from './JobRow';
import { kJobColumns } from './columns';

/** The open construction jobs, the newest car's first. */
export const JobTable = memo(
  ({ jobs, now }: { jobs: Refreshing<WorkshopJob[]>; now: Date }) => (
    <BoardTable
      rows={jobs}
      columns={kJobColumns}
      renderRow={job => <JobRow key={job.id} job={job} now={now} />}
      emptyText="暂无待施工的项目"
      failedText="暂时无法获取施工项目，稍后自动重试"
      countText={items =>
        `共 ${items.length} 项施工 · ${
          new Set(items.map(x => x.licensePlateNo)).size
        } 辆车`
      }
    />
  ),
);
